import { createContext } from 'react'

export const ProductMoreContext = createContext([])